import { useState } from "react";
import { api } from "../lib/api";
import { Sparkles, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function DemoSeedButton({ onSeeded, variant = "button" }) {
  const [busy, setBusy] = useState(false);

  const seed = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/demo/seed");
      if (data.already_seeded) {
        toast.success("Demo data already loaded");
      } else {
        toast.success(`${data.created} demo RFPs loaded`);
      }
      onSeeded?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not seed demo");
    } finally {
      setBusy(false);
    }
  };

  const clear = async () => {
    if (!window.confirm("Remove all demo RFPs from your desk?")) return;
    setBusy(true);
    try {
      await api.post("/demo/clear");
      toast.success("Demo data cleared");
      onSeeded?.();
    } catch {
      toast.error("Could not clear demo");
    } finally {
      setBusy(false);
    }
  };

  if (variant === "icon") {
    return (
      <button
        onClick={clear}
        disabled={busy}
        data-testid="demo-clear-btn"
        title="Clear demo data"
        className="font-mono-data text-[10px] uppercase tracking-widest text-text-secondary hover:text-amber-500 inline-flex items-center gap-1"
      >
        <Trash2 className="w-3 h-3" /> Clear demo
      </button>
    );
  }

  return (
    <button
      onClick={seed}
      disabled={busy}
      data-testid="demo-seed-btn"
      className="btn-tactile inline-flex items-center gap-2"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4 text-amber-500" />}
      Load Demo Data
    </button>
  );
}
